import React from 'react';

const Payment = () => {
  return (
    <div className="text-center">
      <h2>Payment comming soon...</h2>
    </div>
  );
};

export default Payment;